import { z } from 'zod'
 
export const SignupFormSchema = z.object({
  first_name: z
    .string()
    .min(2, { message: 'First name must be at least 2 characters long.' })
    .trim(),
  last_name: z
    .string()
    .min(2, { message: 'last name must be at least 2 characters long.' })
    .trim(),
  org_name: z
    .string()
    .min(2, { message: 'Organisation name must be at least 2 characters long.' })
    .trim(),
  email: z.string().email({ message: 'Please enter a valid email.' }).trim(),
  password: z
    .string()
    .min(8, { message: 'Be at least 8 characters long' })
    .regex(/[a-zA-Z]/, { message: 'Contain at least one letter.' })
    .regex(/[0-9]/, { message: 'Contain at least one number.' })
    .regex(/[^a-zA-Z0-9]/, {
      message: 'Contain at least one special character.',
    })
    .trim(),
  confirm_password: z
    .string()
    .trim()
})
.refine((data) => data.password === data.confirm_password, {
    path: ['confirm_password'],
    message: 'Passwords do not match.',
  });
 
export type FormState =
  | {
      errors?: {
        first_name?: string[]
        last_name?: string[]
        org_name?: string[]
        email?: string[]
        password?: string[]
        confirm_password?: string[]
      }
      message?: string
    }
  | undefined